import * as yup from 'yup';

const checkoutActivitySchema = yup.object().shape({
  first_name_traveler: yup.string().required('First name is required'),
  last_name_traveler: yup.string().required('Last name is required'),
  pickup_loc: yup.string().required('Pickup location is required'),
});

export default checkoutActivitySchema;
